import React from 'react'
import AuthCenterContext from './AuthCenterContext'

export default function useAuthCenter () {
    return React.useContext(AuthCenterContext)
}